var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.route)?_c('router-link',{staticClass:"btn btn-default btn-edit",attrs:{"to":_vm.route}},[_vm._v(_vm._s(_vm._f("trans")('Edit')))]):_c('btn',_vm._g(_vm._b({staticClass:"btn-edit",attrs:{"icon":"pencil","iconset":"fa"}},'btn',_vm.$attrs,false),_vm.$listeners),[_vm._v(_vm._s(_vm._f("trans")('Edit')))])
}
var staticRenderFns = []

export { render, staticRenderFns }